export const EMAIL_EVENT_TYPES = [
    'TICKET_CREATED',
    'STATUS_CHANGED',
    'COMMENT_ADDED',
    'SLA_WARNING',
    'SLA_BREACH',
    'TICKET_ESCALATED',
    'TICKET_RESOLVED',
    'TICKET_REOPENED',
    'MENTIONED',
];
/** Maps NotificationPrefs keys to which email event types they control */
export const PREF_TO_EVENTS = {
    ticket_assigned: ['TICKET_CREATED'],
    status_change: ['STATUS_CHANGED', 'TICKET_RESOLVED'],
    comment_on_tickets: ['COMMENT_ADDED'],
    sla_warning: ['SLA_WARNING'],
    sla_breach: ['SLA_BREACH'],
    escalation: ['TICKET_ESCALATED'],
    ticket_reopened: ['TICKET_REOPENED'],
    mentioned: ['MENTIONED'],
};
/** Reverse lookup: which NotificationPrefs key controls a given email event type (null if unmapped). */
export function prefKeyForEmailEvent(eventType) {
    for (const [prefKey, events] of Object.entries(PREF_TO_EVENTS)) {
        if (events.includes(eventType))
            return prefKey;
    }
    return null;
}
/**
 * Pref keys whose GROUP-level default is OFF, so members of a group are not auto-subscribed
 * to high-frequency events (reduces notification overload). A member can still opt in via their
 * personal profile (personal prefs always win), and an admin can override per-group.
 */
export const GROUP_DEFAULT_OFF_PREFS = ['comment_on_tickets', 'status_change'];
/**
 * Pref keys that are "directed" at a specific person, and are therefore always emailed to that
 * individual — never replaced by / routed to a group's shared mailbox (assignment, @mention,
 * and the creator's own ticket-created confirmation).
 */
export const DIRECTED_EMAIL_PREFS = ['ticket_assigned', 'mentioned', 'ticket_created'];
/** Maps in-app notification event types to the NotificationPrefs key that controls them */
export const INAPP_EVENT_TO_PREF = {
    TICKET_CREATED: 'inapp_ticket_created',
    ASSIGNED: 'inapp_ticket_assigned',
    COMMENT_ADDED: 'inapp_comment_on_tickets',
    INTERNAL_NOTE_ADDED: 'inapp_comment_on_tickets',
    ATTACHMENT_ADDED: 'inapp_comment_on_tickets',
    STATUS_CHANGED: 'inapp_status_change',
    PRIORITY_CHANGED: 'inapp_status_change',
    ESCALATED: 'inapp_escalation',
    DE_ESCALATED: 'inapp_escalation',
    TICKET_REOPENED: 'inapp_ticket_reopened',
    MENTIONED: 'inapp_mentioned',
};
//# sourceMappingURL=email-events.js.map